module.exports = __webpack_public_path__ + "9ab2c91550656dcd9318152dcadaedba.svg";